import {ColumnsType} from "antd/lib/table";
import {ApplicationUserDto, BasketDto, BasketItemDto, DiscountCodeDto} from "../../api";
import {CrudTable, nameof} from "digimuth-components/dist";
import {CrudTableWrapperProps} from "digimuth-components/dist/components/crudTable/crudTable";
import moment from "moment";
import {Button} from "antd";
import {generatePath, useNavigate} from "react-router-dom";
import {RoutingPaths} from "../routing/routingContainer";

export default function BasketsList(props: CrudTableWrapperProps<BasketDto, string>) {

    const navigate = useNavigate();

    const columns: ColumnsType<BasketDto> = [
        {
            key: nameof<BasketDto>("id"),
            dataIndex: nameof<BasketDto>("id"),
        },
        {
            key: nameof<BasketDto>("user"),
            dataIndex: nameof<BasketDto>("user"),
            title: "Użytkownik",
            render: (v: ApplicationUserDto) => (v !== null && v.firstName !== null && v?.lastName !== null) ?
                <div>{v.firstName} {v.lastName}</div> : <div>Użytkownik niezalogowany</div>
        },
        {
            key: nameof<BasketDto>("readDate"),
            dataIndex: nameof<BasketDto>("readDate"),
            title: "Ostatnio zmodyfikowano",
            render: v => <div>{moment(v).format('DD.MM.YYYY, HH:mm')}</div>
        },
        {
            key: nameof<BasketDto>("discountCode"),
            dataIndex: nameof<BasketDto>("discountCode"),
            title: "Kod rabatowy",
            render: (v: DiscountCodeDto) => v !== null && <div>{v.code}</div>
        },
        {
            key: "BasketValue",
            dataIndex: nameof<BasketDto>("items"),
            title: "Wartość produktów w koszyku",
            render: (items: BasketItemDto[]) => <div>
                {items && items.length > 0
                    ? items.reduce((acc, item) => {
                        const price = item.price || 0;
                        const count = item.count || 0;
                        return acc + (price * count);
                    }, 0).toFixed(2)
                    : '0.00'}
            </div>
        }
    ];

    return <>
        <CrudTable
            data={props.data || []}
            onAddClicked={props.onAddClicked}
            onEditClicked={props.onEditClicked}
            onDeleteClicked={props.onDeleteClicked}
            isLoading={props.isLoading}
            deleteButtonTitle={"Usuń"}
            deleteConfirmMessage={"Czy na pewno chcesz usunąć ten wpis?"}
            cancelButtonTitle="Anuluj"
            columns={columns}
            customRowActions={(row) => <Button
                onClick={() => navigate(generatePath(RoutingPaths.basketProducts.route, {basketId: row.id}))}
            >
                Produkty w koszyku
            </Button>}
        />
    </>
}
